import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';

const PageHeader = ({ loadList,loading }) => {


return (
<div className="mb-8">
<div className="flex items-center justify-between mb-4">
<div>
<h1 className="text-xl lg:text-3xl font-bold text-text-primary mb-2">Notifications</h1>
<p className="text-text-secondary text-sm">
Discover AI-powered job recommendations tailored to your profile
</p>
</div>

<div className="hidden md:flex items-center space-x-3">
<Button
variant="outline"
iconName="RefreshCw"
iconPosition="left"
iconSize={16}
onClick={loadList}
disabled={loading}
>
Refresh
</Button>
</div>
</div>
</div>
);
};

export default PageHeader;